import { REPORTS_ROUTES } from '../../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import reportsTypes from '../../constants/reportsTypes'
import { axios } from '../../services'

// 0 Sidebar helpers
// 1 archive
// 2 restore
// 3 destroy
// 4 Get Archive
// 5 Get Project Archive

// 0 Sidebar helpers
const show_archive_sidebar_report_actions = () => {
  return {
    type: "SHOW_ARCHIVE_SIDEBAR_REPORT_ACTIONS"
  }
}

const hide_archive_sidebar_report_actions = () => {
  return {
    type: "HIDE_ARCHIVE_SIDEBAR_REPORT_ACTIONS"
  }
}

// 1 archive = add to Trash
const archive_report_request = () => {
  return {
    type: reportsTypes.archive.request
  }
}

const archive_report_success = (response) => {
  return {
    type: reportsTypes.archive.success,
    payload: response.data
  }
}

const archive_report_failure = (messages) => {
  return {
    type: reportsTypes.archive.failure,
    payload: messages
  }
}

const archive_report = (report_id, page=1) => {
  return function(dispatch) {
    // Before Request
    dispatch( archive_report_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.archive, {id: report_id}),
      {
        page: page,
        per_page: 10
      }
    ).then( response => {
      // success
      dispatch( archive_report_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error archiving report."]
      }
      dispatch( archive_report_failure( errors ) )
    })
  }
}

// 2 restore = from Trash back to active
const restore_report_request = () => {
  return {
    type: reportsTypes.restore.request
  }
}

const restore_report_success = (response) => {
  return {
    type: reportsTypes.restore.success,
    payload: response.data
  }
}

const restore_report_minimal_success = (response) => {
  return {
    type: reportsTypes.restore.success_minimal,
    payload: response.data
  }
}

const restore_report_failure = (messages) => {
  return {
    type: reportsTypes.restore.failure,
    payload: messages
  }
}

const restore_report = (report_id, page=1, show="standard") => {
  return function(dispatch) {
    // Before Request
    dispatch( restore_report_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.restore, {id: report_id}),
      {
        page: page,
        per_page: 10,
        show: show
      }
    ).then( response => {
      // success
      if (show === "minimal") {
        dispatch( restore_report_minimal_success(response) )
      } else {
        dispatch( restore_report_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error restoring report."]
      }
      dispatch( restore_report_failure( errors ) )
    })
  }
}

// 3 destroy = permanently delete
const destroy_report_request = () => {
  return {
    type: reportsTypes.destroy.request
  }
}

const destroy_report_success = (response) => {
  return {
    type: reportsTypes.destroy.success,
    payload: response.data
  }
}

const destroy_report_failure = (messages) => {
  return {
    type: reportsTypes.destroy.failure,
    payload: messages
  }
}

const destroy_report = (report_id, page=1) => {
  return function(dispatch) {
    // Before Request
    dispatch( destroy_report_request() )

    // Request
    axios.delete(
      formatRoute(REPORTS_ROUTES.destroy, {id: report_id}),
      {
        params: {
          page: page,
          per_page: 10
        }
      }
    ).then( response => {
      // success
      dispatch( destroy_report_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error destroying report."]
      }
      dispatch( destroy_report_failure( errors ) )
    })
  }
}

// 4 Get Archive
const reports_archive_request = () => {
  return {
    type: reportsTypes.index.request
  }
}

const reports_archive_success = (response) => {
  return {
    type: reportsTypes.index.success,
    payload: response.data
  }
}

const reports_archive_failure = (messages) => {
  return {
    type: reportsTypes.index.failure,
    payload: messages
  }
}

const reports_archive = (page=1) => {
  return function (dispatch) {
    // Before Request
    dispatch(reports_archive_request())

    // Request
    axios.get(
      REPORTS_ROUTES.archive_index,
      {
        params: {
          page: page,
          per_page: 10
        }
      }
    ).then( response => {
      // success
      dispatch( reports_archive_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching reports."]
      }
      dispatch( reports_archive_failure(errors))
    })
  }
}

// 5 Get Project Archive
const project_archive_request = () => {
  return {
    type: reportsTypes.project_archive.request
  }
}

const project_archive_success = (response) => {
  return {
    type: reportsTypes.project_archive.success,
    payload: response.data
  }
}

const project_archive_failure = (messages) => {
  return {
    type: reportsTypes.project_archive.failure,
    payload: messages
  }
}

const project_archive = (report_id, page=1) =>{
  return function (dispatch) {
    // Before Request
    dispatch(project_archive_request())

    // Request
    axios.get(
      formatRoute(REPORTS_ROUTES.archive, {id: report_id}),
      {
        params: {
          page: page,
          per_page: 10
        }
      }
    ).then( response => {
      // success
      dispatch( project_archive_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        // errors = ["Error fetching archived reports."]
        errors = [error]
      }
      dispatch( project_archive_failure(errors))
    })
  }
}


export {
  show_archive_sidebar_report_actions,
  hide_archive_sidebar_report_actions,
  archive_report,
  restore_report,
  destroy_report,
  reports_archive,
  project_archive
}



// WEBPACK FOOTER //
// ./src/js/actions/reports/archive_actions.js